import React from 'react';
import { ButtonGroup, Button } from 'reactstrap';
import { useHistory } from 'react-router-dom';

const ResetPasswordSuccess = () => {
  const history = useHistory();
  function handleClick() {
    history.push('/login');
  }
  return (
    <>
      <div className="reset-password-wrapper reset-success">
        <div className="form-container">
          <span className="icon icon-round-check" />
          <h2>Great!</h2>
          <p>
            Your password has been reset. You can now login using your new credentials.
          </p>
          <ButtonGroup className="justify-content-center p-0">
            <Button
              color="primary"
              size="lg"
              element="inlineBlock"
              type="submit"
              onClick={handleClick}
            >
              Sign in to BYGmusic
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </>
  );
};

export default ResetPasswordSuccess;
